import { useCMSPage } from "../../../context/CMSContext";

const DEFAULT_TIPS = [
  { icon: "ri-list-check-2",      title: "Tick everything going",   desc: "Include sofas, mattresses, fridges, bin bags, garden waste, rubble — each item adds estimated volume and weight." },
  { icon: "ri-map-pin-2-line",    title: "Drop your postcode",      desc: "Midlands postcodes route to your nearest depot for fastest same-day availability and accurate pricing." },
  { icon: "ri-scales-3-line",     title: "Weight only matters for heavy stuff", desc: "For sofas, bags and furniture, volume drives the price. Rubble, soil and plasterboard factor weight in — we'll flag it." },
  { icon: "ri-price-tag-3-line",  title: "Price you see is what you pay", desc: "95% of standard jobs: the calculator price is the final price. The 5% exception: very large jobs or hidden access issues we'd flag on the quote." },
];

export default function CalcTips() {
  const { data: calcCMS } = useCMSPage("calculator");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tipsCMS: any = (calcCMS as any)?.tips ?? {};

  const headline = tipsCMS?.headline ?? "How to get the best estimate.";
  const items    = tipsCMS?.items?.length ? tipsCMS.items : DEFAULT_TIPS;

  return (
    <div className="bg-cl-tint rounded-2xl cartoon-card p-6 mb-2">
      <h3 className="font-black text-cl-dark text-base mb-5">{headline}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {items.map((tip: { icon: string; title: string; desc: string }, i: number) => (
          <div key={i} className="flex gap-3">
            <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-dark flex-shrink-0">
              <i className={`${tip.icon} text-cl-dark text-sm`}></i>
            </span>
            <div>
              <h4 className="font-black text-cl-dark text-sm mb-0.5">{tip.title}</h4>
              <p className="text-cl-dark/60 text-xs font-semibold leading-relaxed">{tip.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
